<div class="payments-container line">
  <div
    class="payments-container-label calendar"
    [class.toggle-enabled]="showToggleIcon"
    (click)="toggleCollapsed()"
    (keydown)="onHeaderKeydown($event)"
    [attr.role]="showToggleIcon ? 'button' : null"
    [attr.tabindex]="showToggleIcon ? '0' : null"
    [attr.aria-expanded]="showToggleIcon ? (!isCollapsed).toString() : null">
    <span class="calendar-title">{{ "webPos.CalendarOfPayments" | translate }} </span>
    @if (showToggleIcon) {
      <span class="toggle-icon" aria-hidden="true">{{ isCollapsed ? '▾' : '▴' }}</span>
    }
  </div>
  @if (!isCollapsed) {
    <div class="payments-info" *ngFor="let payment of payments">
      <div class="payments-info-block">
        <span>{{ "webPos.Maturity" | translate }}: </span>
        <span>{{ payment.dueDate | localizedDate }}</span>
      </div>
      <div class="payments-info-block payments-info-block--amount">
        <span class="payments-info--bold">
          {{ payment.amount | hcurrency : payment.currency }}
        </span>
      </div>
    </div>
  }
</div>